import React, { useState, useEffect, useMemo } from "react";
import { Card, List, Typography, Tag, Button, Empty, Row, Col, Popconfirm, Input } from "antd";
import { UserOutlined, EnvironmentOutlined, UserDeleteOutlined, HomeOutlined, PhoneOutlined, SearchOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Search } = Input;

export default function CurrentParticipants({ participantesActuales, onQuitarParticipante, ecaOid }) {
  const [participantes, setParticipantes] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4;

  useEffect(() => {
    if (!participantesActuales?.length) return;
    setParticipantes(participantesActuales);
  }, [participantesActuales]);

  const filteredParticipantes = useMemo(() => {
    return participantes.filter((p) =>
      p.nombre_participante?.toLowerCase().includes(searchText.toLowerCase()) ||
      p.numero_identificacion?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [participantes, searchText]);

  const paginatedParticipantes = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredParticipantes.slice(start, start + pageSize);
  }, [filteredParticipantes, currentPage]);
  const totalPages = Math.ceil(filteredParticipantes.length / pageSize);
  if (participantesActuales.length === 0) {
    return (
      <div style={{ minHeight: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Empty description="No hay participantes en esta ECA" />
      </div>
    );
  }
  return (
    <div style={{ padding: 8 }}>
      <Card
        style={{
          marginBottom: 16,
          padding: 12,
          backgroundColor: "#f0f9ff",
          borderColor: "#91d5ff",
        }}
      >
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Text type="secondary">
              <strong>{participantesActuales.length}</strong> participante(s) en esta ECA
            </Text>
          </Col>
          <Col xs={24} sm={12} style={{ textAlign: "right" }}>
            <Search
              placeholder="Buscar por nombre o identificación"
              allowClear
              onSearch={(value) => {
                setSearchText(value);
                setCurrentPage(1);
              }}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
              enterButton={<SearchOutlined style={{ color: "#1890ff" }} />} 
              style={{ maxWidth: 320 }}
            />
          </Col>
        </Row>
      </Card>
      <List
        grid={{ gutter: 16, xs: 1, sm: 1, md: 1, lg: 1, xl: 2, xxl: 2 }}
        dataSource={paginatedParticipantes}
        locale={{ emptyText: "No se encontraron participantes" }}
        pagination={false}
        renderItem={(participante) => (
          <List.Item key={participante.oid}>
            <Card hoverable style={{ padding: 10 }}>
              <Row justify="space-between" align="middle" gutter={[8, 8]}>
                <Col xs={24} sm={18}>
                  <Text strong style={{ fontSize: 16 }}>
                    <UserOutlined /> {participante.nombre_participante.trim()}
                  </Text>
                  <div style={{ marginTop: 6 }}>
                    <Tag color="cyan">Documento: {participante.numero_identificacion}</Tag>
                  </div>
                  <div style={{ marginTop: 6, fontSize: 13, color: "#666" }}>
                    <div style={{ fontSize: 12, color: "#666" }}>
                      <HomeOutlined /> {participante.departamento} |{" "}
                      <EnvironmentOutlined /> {participante.municipio} | <PhoneOutlined />{" "}
                      {participante.telefono}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={6} style={{ textAlign: "right" }}>
                  <Popconfirm
                    title={`¿Quitar a ${participante.nombre_participante.trim()}?`}
                    description="Este participante volverá a estar disponible para otras ECAs."
                    onConfirm={() => {
                      onQuitarParticipante(participante.oid);
                    }}
                    okText="Sí"
                    cancelText="No"
                    okButtonProps={{ danger: true }}
                  >
                    <Button
                      danger
                      icon={<UserDeleteOutlined />}
                      size="small"
                    >
                      Quitar
                    </Button>
                  </Popconfirm>
                </Col>
              </Row>
            </Card>
          </List.Item>
        )}
      />
      {totalPages > 1 && (
        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            style={{ marginRight: 8 }}
          >
            Anterior
          </Button>
          <Text>
            Página {currentPage} de {totalPages}
          </Text>
          <Button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            style={{ marginLeft: 8 }}
          >
            Siguiente
          </Button>
        </div>
      )}
    </div>
  );
}